import Accordion from './components/Accordion';

function initAccordions() {
    Accordion.create('[data-accordion]');
}

function initFilters() {
    const categorySelectBox = document.querySelector('[data-category-select]');
    const industrySelectBox = document.querySelector('[data-industry-select]');
    const selects = document.querySelectorAll('[data-category-select], [data-industry-select]');

    for (const select of selects) {
        select.addEventListener('change', function() {
            filterByCategoryOrIndustry(
                this.getAttribute('data-testimonials-base-url'),
                categorySelectBox.options[categorySelectBox.selectedIndex].value,
                industrySelectBox.options[industrySelectBox.selectedIndex].value
            );
        });
    }
}

function filterByCategoryOrIndustry(basepath, category, industry) {
    const url = `${basepath}/${category}/${industry}`;
    document.location.href = url.replace(/(\/all)+$/, '');
}

function setValueForSelectOrDefault(selectFieldSelector, value) {
    const options = Array.from(
        document.querySelector(selectFieldSelector).querySelectorAll('option')
    );
    const hasValidValue = options.map(o => o.value).includes(value);
    if (!value || !hasValidValue) {
        document.querySelector(selectFieldSelector).value = 'all';
    }
    if (hasValidValue) {
        document.querySelector(selectFieldSelector).value = value;
    }
}

function syncFiltersAndUrlPath() {
    const path = window.location.pathname;
    const [, , category, industry] = path.split('/');

    setValueForSelectOrDefault('[data-category-select]', category);
    setValueForSelectOrDefault('[data-industry-select]', industry);
}

document.addEventListener('DOMContentLoaded', () => {
    initAccordions();
    initFilters();
    syncFiltersAndUrlPath();
});
